<template>
  <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" :language="this.language" @verify="validate"/>
</template>
<script>
import {VueRecaptcha} from 'vue-recaptcha'
import Validation from '../services/recaptchaValidate'
import Vue from 'vue'
export default {
  name: "Recaptcha",
  components: {VueRecaptcha},
  data () {
    return {
      sitekey: Vue.prototype.$config.grecaptchaPublicKey,
      language: this.$route.query.lang ? this.$route.query.lang : 'en'
    }
  },
  methods: {
    validate (response) {
      Validation.validate({response: response}).then(result => {
        this.$emit('validate', result.success)
      }).catch(error => console.log(error))
    }
  }
}
</script>